import React from 'react';
import { Film, Youtube, Newspaper, UtensilsCrossed, Music, Brain } from 'lucide-react';
import { services } from '../data/mock';

const ServicesSection = () => {
  const iconMap = {
    Film,
    Youtube,
    Newspaper,
    UtensilsCrossed,
    Music,
    Brain
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-[#0077cc]">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive content solutions across multiple platforms and formats
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="p-3 bg-gradient-to-br from-[#0077cc] to-[#00c6d7] rounded-xl">
                    <Icon className="text-white" size={28} />
                  </div>
                  <span className="text-sm font-semibold text-[#00c6d7] bg-[#00c6d7]/10 px-3 py-1 rounded-full">
                    {service.stats}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
